import orderBy from 'lodash/orderBy';
import formatNumber from '@framework/data-helpers/formatters/formatNumber';
import ITranch from '@/creditflowresearch/domain/vo/Tranch/ITranch';
import { IRegionFilter } from '@/creditflowresearch/application/PageFilters/hooks/create/useCreateRegionFilters';
import { IProductFilter } from '@/creditflowresearch/application/PageFilters/hooks/create/useCreateProductFilters';

export const formatDataCell = <T>(cellData: T, instead = '-'): T | string => cellData || instead;

export function formatNumberWithDecimals(number: string | number, decimals: number): string {
  return formatNumber(+number, { decimals });
}

export const formatTenorCell = (
  tenor: number | string,
  perpetual: boolean,
  decimals: number,
) => {
  if (tenor) return formatDataCell(tenor && formatNumberWithDecimals(tenor, decimals));
  return perpetual ? 'Perp' : '-';
};

export function getSortedTranches(tranches: ITranch[]) {
  if (!tranches.length) {
    return tranches;
  }

  return orderBy(tranches, (tranche) => tranche.orderingPosition);
}

export function getTrancheFieldWithPercent(field: string | number, decimals: number) : string | number {
  if (/^\d+(\.\d+)?$/.test(`${ field }`)) {
    field = (`${ field }`).replace('%', '');
    return `${ formatNumberWithDecimals(field, decimals) }%`;
  }
  return field;
}

interface ISubscribeTexts {
  isSubscribed: boolean,
  productIds: string[],
  regionIds: string[],
  products: IProductFilter[],
  regions: IRegionFilter[],
}

export const getSubscribeTexts = (
  {
    isSubscribed,
    productIds,
    regionIds,
    products,
    regions,
  }: ISubscribeTexts,
  isSuccessMessage?: boolean,
) : string => {
  if (productIds.length > 1 || regionIds.length > 1 || !products?.length || !regions?.length) {
    return '';
  }

  const region = regions.find((region) => region.id === regionIds[0]);
  const product = products.find((product) => product.id === productIds[0]);
  const regionShortName = region?.shortDisplayName || '';
  const productAbbreviation = product?.abbreviation || '';
  const regionWithPrefixWord = regionShortName === 'US' ? `the ${ regionShortName }` : regionShortName;
  const productAndRegion = `${ regionWithPrefixWord } ${ productAbbreviation }`;

  if (isSuccessMessage) {
    return `You have successfully subscribed to ${ productAndRegion } Weekly Digest.`;
  }

  return isSubscribed
    ? `Subscribed to ${ productAndRegion } Weekly Digest`
    : `Subscribe to ${ productAndRegion } Weekly Digest`;
};
